import React from 'react';
import {components, type NoticeProps} from 'react-select';

type CustomNoOptionsMessageProps = NoticeProps & {
    selectProps: {
        noResultsMessage?: string;
    };
};

const MultiselectNoOptionsMessage = (props: CustomNoOptionsMessageProps) => {
    const {selectProps} = props;
    const displayMessage = selectProps?.noResultsMessage
        ? selectProps.noResultsMessage
        : 'No options found';

    return (
        <components.NoOptionsMessage {...props}>
            {displayMessage}
        </components.NoOptionsMessage>
    );
};

export default MultiselectNoOptionsMessage;
